<div class="info">
  <i class="fal fa-info-circle"></i>
  <p i18n>
    Channel configuration will be used for all rentals by default, unless you set specific rental configurations which
    override channel configuration.
  </p>
</div>
<app-hometogo-channel-config-form
  *ngIf="channel?.name === channelNames.HomeToGo && !!config"
  [title]="'Channel Config'"
  [channel]="channel"
  [taxesFees]="'bulk'"
  [config]="config"
  [primaryButtonClass]="primaryButtonClass"
  (save)="onSave($event)"
></app-hometogo-channel-config-form>
